import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import styles from "./_css/virtualAssistantFinalStepForm.module.css";
import clsx from "clsx";
import { VirtualAssistantPropertiesLoader } from "virtualAssistant/VirtualAssistantPropertiesLoader";
import { TFilter } from "admin/_common/filters/TFilter";
import { propertiesStore } from "properties/_stores/propertiesStore";
import { VirtualAssistantNoResults } from "virtualAssistant/VirtualAssistantNoResults";
import { observer } from "mobx-react";
import { VirtualAssistantFinalButton } from "virtualAssistant/VirtualAssistantFinalButton";
import { getUrlSearchFromFilters } from "properties/searchBar/filters/_utils/filtersUtils";
import { useFormContext } from "react-hook-form";
import i18next from "i18next";

type Props = {
    filters: TFilter[];
    goToStepOne: () => void;
};
export const VirtualAssistantFinalStepForm = observer(({ filters, goToStepOne }: Props) => {
    const { t } = useTranslation();
    const form = useFormContext();

    const listStore = propertiesStore.getListStore("virtual-assistant-summary", undefined, filters);

    const urlFilters = getUrlSearchFromFilters(filters);

    const geoZone = form.watch("geoZone");
    const purpose = form.watch("purpose");

    const searchUrl = `/${i18next.language}/${t("routes.virtualAssistantSummary")}?geozone=${geoZone?.join(
        ",",
    )}&purpose=${purpose.toUpperCase()}&${urlFilters}`;

    useEffect(() => {
        listStore.updateFiltersAndReload(filters);
    }, []);

    return (
        <div className={"flex_column"}>
            <div className={"mt_50"}>
                {listStore.items.length === 0 ? (
                    <VirtualAssistantNoResults goToStepOne={goToStepOne} />
                ) : (
                    <VirtualAssistantPropertiesLoader filters={filters} />
                )}
            </div>
            <div className={clsx("flex_column", styles.agreementContainer)}>
                <div>{t("virtualAssistant.finalStepForm.agreementTitle")}</div>
                <div
                    className={styles.answer}
                    dangerouslySetInnerHTML={{ __html: t("virtualAssistant.finalStepForm.agreementText") }}
                />
            </div>
            <VirtualAssistantFinalButton filterUrl={searchUrl} />
        </div>
    );
});
